import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { TDealStepModalNavigationProps } from '../../containers/DealStepsSectionContainer/utils/useDealStepsModalNavigation';

import * as styles from './styles.css';

export const DealStepsModalActionsDesktop: React.FC<
  React.PropsWithChildren<
    TDealStepModalNavigationProps & {
      action: React.ReactNode;
    }
  >
> = props => {
  return (
    <div className={styles['actions']}>
      <Button theme="fill_secondary" onClick={props.goBackward} disabled={props.isFirstStep}>
        Предыдущий шаг
      </Button>
      <Button onClick={props.goForward} disabled={props.isLastStep}>
        Следующий шаг
      </Button>
      <div className={styles['get-consultation']}>{props.action}</div>
    </div>
  );
};
